import React, { FC, useContext, useState } from 'react';

// hooks
import { useDeleteOrganization, useUpdateActiveStatusOrganization } from 'hooks/organizations';

// components
import EditOrg from 'pages/Organization/EditOrg';
import ButtonPencil from 'shared/components/Buttons/ButtonPencil';
import ButtonSuspending from 'shared/components/Buttons/ButtonSuspending';
import PopupContainer from 'shared/components/PopupContainer';
import ButtonTrash from 'shared/components/Buttons/ButtonTrash';
import PopupConfirmation from 'shared/components/PopupConfirmation';

import { OrganizationsTableContext } from 'shared/components/Table/AdminOrgTable';

// icons
import PlaySVG from 'assets/image/play.svg';
import PauseSVG from 'assets/image/pause.svg';

// types
import { ISearchOrganisationByAdminResponse, ORGANISATION_ACTIVE_STATUS } from '@joc/api-gateway';

// styles
import styles from './OrgActionCell.module.scss';

const OrgActionCell: FC<{ organizationId: string }> = ({ organizationId }) => {
	const [isShowPopup, setIsShowPopup] = useState(false);
	const [isShowDeleteConfirmation, setIsShowDeleteConfirmation] = useState(false);
	const { updateActiveStatusOrganization } = useUpdateActiveStatusOrganization();
	const { deleteOrganization } = useDeleteOrganization();

	const organizationData: ISearchOrganisationByAdminResponse = useContext(OrganizationsTableContext);

	const deleteConfirmClickHandler = async () => {
		deleteOrganization(Number(organizationId));
	};

	return (
		<div>
			<div className={styles.actions__content}>
				<ButtonPencil clickHandler={() => setIsShowPopup(true)} />
				<ButtonTrash clickHandler={() => setIsShowDeleteConfirmation(true)} />

				{organizationData.organizationActiveStatus.status !== ORGANISATION_ACTIVE_STATUS.SUSPENDED ? (
					<ButtonSuspending
						clickHandler={() => {
							updateActiveStatusOrganization({
								organisationId: organizationData.id,
								status: ORGANISATION_ACTIVE_STATUS.SUSPENDED,
							});
						}}
						title="suspend organization"
						href={PauseSVG}
					/>
				) : (
					<ButtonSuspending
						clickHandler={() => {
							updateActiveStatusOrganization({
								organisationId: organizationData.id,
								status: ORGANISATION_ACTIVE_STATUS.ACTIVE,
							});
						}}
						title="suspend organization"
						href={PlaySVG}
					/>
				)}
			</div>
			{isShowPopup && (
				<PopupContainer setIsShowPopup={setIsShowPopup} isDisablePadding={true}>
					<EditOrg setIsShowPopup={setIsShowPopup} />
				</PopupContainer>
			)}
			{isShowDeleteConfirmation && (
				<PopupConfirmation
					confirmClickHandler={deleteConfirmClickHandler}
					cancelClickHandler={() => setIsShowDeleteConfirmation(false)}
					setIsShowPopup={setIsShowDeleteConfirmation}
				/>
			)}
		</div>
	);
};

export default OrgActionCell;
